import packageIcon from 'assets/package-assets/package-ffffff.svg';
import { ICustomerServicePackage } from 'features/cashier/services/types/customer-service-package';
import { getPackageThemeByType } from 'features/cashier/services/package-theme';
import { Calendar, ChevronRight } from 'lucide-react';
import { PackageCardStyled } from './styles';

interface IPackageCardProps {
  data: ICustomerServicePackage;
  onOpenDetail: () => void;
}

/** Thẻ một gói của khách. Dùng buổi đi qua modal chi tiết, thẻ không có nút dùng nhanh */
const PackageCard = ({ data, onOpenDetail }: IPackageCardProps) => {
  const themeKey = getPackageThemeByType(data.type);

  return (
    <PackageCardStyled themeKey={themeKey} onClick={onOpenDetail}>
      <div className='package-icon'>
        <img src={packageIcon} alt='' />
        <span className='tier-badge'>{data.tierName}</span>
      </div>
      <span className='divider' />

      <div className='package-info'>
        <span className='program-name'>{data.programName}</span>
        <span className='expires'>
          <Calendar size={16} />
          Expires on: {data.expiredAt}
        </span>
      </div>

      <span className='sessions'>
        <strong>{data.remainingQuantity}</strong>/{data.totalQuantity} sessions
      </span>

      <ChevronRight size={22} />
    </PackageCardStyled>
  );
};

export default PackageCard;
